import { render, staticRenderFns } from "./MyProductsUnits.vue?vue&type=template&id=7a685a52"
import script from "./MyProductsUnits.vue?vue&type=script&lang=js"
export * from "./MyProductsUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports